import { gql } from "@apollo/client";

export const INVITE_PATIENT = gql`
   mutation Mutation(
      $patient: UserInput
      $careKeeper: UserInput
      $familyInvite: Boolean
      $selectedPatientId: ID
      $reInvite: Boolean
      $relationship: String
      $teamId: String
      $contentIds: [String]
      $doctorId: String
      $subAccount: Boolean
      $noNotification: Boolean
   ) {
      addPatient(
         patient: $patient
         careKeeper: $careKeeper
         familyInvite: $familyInvite
         selectedPatientId: $selectedPatientId
         reInvite: $reInvite
         relationship: $relationship
         teamId: $teamId
         contentIds: $contentIds
         doctorId: $doctorId
         subAccount: $subAccount
         noNotification: $noNotification
      ) {
         status {
            code
            message
         }
         user {
            id
         }
      }
   }
`;
